import styled from 'styled-components';

export const ContainerComponent = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 40px 25px;
`;
